import { render } from "./competence-update-competence-category2.vue?vue&type=template&id=2b88ce3c&scoped=true"
import script from "./competence-update-competence-category2.vue?vue&type=script&lang=js"
export * from "./competence-update-competence-category2.vue?vue&type=script&lang=js"

import "./competence-update-competence-category2.vue?vue&type=style&index=0&id=2b88ce3c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b88ce3c"],['__file',"src/components/applications/competence/update/competence-update-competence-category2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b88ce3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b88ce3c', __exports__)) {
    api.reload('2b88ce3c', __exports__)
  }
  
  module.hot.accept("./competence-update-competence-category2.vue?vue&type=template&id=2b88ce3c&scoped=true", () => {
    api.rerender('2b88ce3c', render)
  })

}


export default __exports__